export default {
    methods: {
        /**
         * Get display name
         * Display name in e.g. select list etc.
         * @param {String|Object} option - Usually current option when looping through an array of options
         */
        getDisplayName(option) {
            if (typeof option === 'object' && this.displayKey) {
                return option[this.displayKey]
            } else {
                return option
            }
        },

        /**
         * Check if option is selected
         * Always array loop for multi selects. Priority objects: uniqueIdKey, valueKey, nameKey
         * @param {String|Object} option - Usually current option when looping through an array of options
         */
        isSelected(option) {
            if (this.value) {
                const valuesArray = Array.isArray(this.value) ? this.value : [this.value]
                const optionType = typeof option

                return valuesArray.find(value => {
                    if (optionType === 'object' && this.uniqueIdKey) {
                        return value[this.uniqueIdKey] === option[this.uniqueIdKey]
                    } else if (optionType === 'object' && this.valueKey) {
                        return value === option[this.valueKey]
                    } else if (optionType === 'object') {
                        return value[this.displayKey] === option[this.displayKey]
                    } else {
                        return value === option
                    }
                })
            }
        },

        /**
         * Get option value
         * Returns property value if valueKey is set, converts objects to json string or returns string
         */
        getSelectOptionValue(option) {
            if (typeof option === 'object' && this.valueKey) {
                const value = option[this.valueKey]
                if (!value)
                    throw new Error(
                        `Could not get property ${
                        this.valueKey
                        } (make sure valueKey on select-single exists in options)`
                    )
                return option[this.valueKey]
            } else if (typeof option === 'object') {
                return JSON.stringify(option)
            } else {
                return option
            }
        }
    }
}
